module.exports = __webpack_public_path__ + "media/assets/images/icons/warning-8f5f96bc95205b85d4d70bd98671b423.svg";